import React, { useState } from 'react'
import ReactPaginate from 'react-paginate';


const Pagination = () => {
  const [pageCount, setPageCount] = useState(15);
  const [currentpage, setCurrentpage] = useState(1);
  const handlePageClick = (count) => {
    setCurrentpage(count.selected + 1)
  }
  return (
    <>
      <div className="paginationbar d-sm-flex justify-content-between align-items-center bg-color-3 bg-color-1-dark p-3 mt-4">
        <ReactPaginate
          breakLabel="..."
          // nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          // previousLabel="< previous"
          renderOnZeroPageCount={null}
        />
        <p className="text level-7 mb-0 mt-sm-0 primary-medium-font inner-color body-color-dark">
          Showing 1 To {pageCount} Of {currentpage}
          {/* (15 Pages) */}
        </p>
      </div>
    </>
  )
}

export default Pagination
